onReady(() => {
    const pdfDiv = document.getElementById('adobe-dc-view');

    if (!pdfDiv) {
        return;
    }

    document.addEventListener("adobe_dc_view_sdk.ready", () => {
        const adobeDCView = new AdobeDC.View({
            clientId: pdfDiv.getAttribute('data-id'),
            divId: 'adobe-dc-view',
        });
        adobeDCView.previewFile({
            content: {
                location: {
                    url: pdfDiv.getAttribute('data-path'),
                },
            },
            metaData: {
                fileName: pdfDiv.getAttribute('data-title'),
            },
        }, {
            embedMode: 'IN_LINE',
            showDownloadPDF: false,
            showPrintPDF: false,
        });
    });
    loadScript('https://acrobatservices.adobe.com/view-sdk/viewer.js');
})
